import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../api/client';
import { useSession } from '../app/session';
import { ErrorBox, Field, PageHeader } from '../components/ui';

export function SettingsPage() {
  const { me } = useSession();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const change = useMutation({
    mutationFn: () => api.post('/auth/password', { current, next }),
    // Changing the password signs out every session, including this one.
    onSuccess: () => (window.location.href = '/login'),
  });
  return (
    <>
      <PageHeader title="Settings" sub={`${me.organization.name} · deployment: ${me.deploymentMode}`} />
      <div className="card stack" style={{ maxWidth: 420 }}>
        <h2>Change password</h2>
        <Field label="Current password">
          <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" />
        </Field>
        <Field label="New password" hint="At least 10 characters. You will be signed out everywhere.">
          <input type="password" value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" />
        </Field>
        <ErrorBox error={change.error} />
        <div>
          <button className="btn primary" disabled={!current || next.length < 10 || change.isPending} onClick={() => change.mutate()}>
            Change password
          </button>
        </div>
      </div>
    </>
  );
}
